import type { FC } from 'react';
import ContentLoader from 'react-content-loader';

import { createArray } from 'app/utils/array';

import style from './style.scss';

interface Props {
  nbLines?: number;
}

const SQUARE_SIZE = 16;
const LINE_HEIGHT = 19;

const BlueprintMarketsPlaceholder: FC<Props> = ({ nbLines = 3 }) => (
  <div className={style.container}>
    {createArray(nbLines).map((_, index) => (
      <div className={style.line} key={index}>
        <ContentLoader width={643}>
          <rect key={`${index}-icon`} x={27} y={23} width={SQUARE_SIZE} height={SQUARE_SIZE} />
          <rect key={`${index}-content`} x={88} y={23} width={438} height={LINE_HEIGHT} />
        </ContentLoader>
      </div>
    ))}
  </div>
);

BlueprintMarketsPlaceholder.displayName = 'BlueprintMarketsPlaceholder';

export default BlueprintMarketsPlaceholder;
